jQuery(document).ready(function($) {

$(document).on('click', '.teamPopup', function (e) 
{
	if ($(e.target).closest('a').length) 
	{
 		return;
  	}
  	var link = $(this).find('a').attr('href');
    if (link && link.trim() !== '') 
    {
    return;
    }  

    var $section = $(this).closest('.cus-team-sec');
    var image = $(this).data('image');
    var name = $(this).data('name');
    var designation = $(this).data('designation');
    var bio = $(this).data('bio'); 
    var $popup = $section.find('.team-popup');
    $popup.find('.popup-image').attr('src', image);
    $popup.find('.popup-name').text(name);
    $popup.find('.popup-designation').text(designation);
    $popup.find('.popup-bio').html(bio);
    $popup.addClass('active');
    $('body').addClass('overflow_hidden');
}); 

$(document).on('click', '.team-popup-close, .team-popup-overlay', function () 
{ 
    var $popup = $(this).closest('.team-popup');
    $popup.removeClass('active');
    $('body').removeClass('overflow_hidden');
});

/* Disclaimer popup */

$(document).on('click', '.disclaimer_cta', function (e) 
{ 
    e.preventDefault();
    //console.log("clicked");
    $('.disclaimer-popup').addClass('active');
    $('body').addClass('scroll-hide');
    $('.wrap').css('z-index', '12');
}); 

$(document).on('click', '.disclaimer-popup-close, .disclaimer-overlay', function () 
{ 
    $('.disclaimer-popup').removeClass('active');
    $('body').removeClass('scroll-hide');
    $('.wrap').css('z-index', '');
    removeAttr('style');
});



/* Disclaimer popup End */

});